export const GENDER = {
  MALE: 1,
  FEMALE: 2,
  OTHER: 3,
  PREFER_NOT_TO_SAY: 4,
} as const;

export type GenderKey = keyof typeof GENDER;
export type GenderValue = typeof GENDER[GenderKey];

export const GENDER_LABELS: Record<GenderValue, string> = {
  [GENDER.MALE]: 'Male',
  [GENDER.FEMALE]: 'Female',
  [GENDER.OTHER]: 'Other',
  [GENDER.PREFER_NOT_TO_SAY]: 'Prefer not to say',
};

export const GENDER_OPTIONS = Object.entries(GENDER).map(([key, value]) => ({
  label: GENDER_LABELS[value],
  value,
}));

export function getGenderLabel(value: number): string {
  return GENDER_LABELS[value as GenderValue] ?? 'Unknown';
}

export function isValidGender(value: any): value is GenderValue {
  return Object.values(GENDER).includes(value);
}
